// src/services/AuthService.js

// const API_BASE_URL = 'http://localhost:5142/api';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Register student
export async function registerStudent(registerData) {
  const response = await fetch(`${API_BASE_URL}/Student/StudentRegister`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(registerData)
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.failMessage || 'Kayıt başarısız oldu');
  }
  return response.json();
}

// Login student
export async function loginStudent(loginData) {
  const response = await fetch(`${API_BASE_URL}/Student/StudentLogin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(loginData)
  });

  const data = await response.json();

  if (!response.ok) {
    if (response.status === 400) {
      throw new Error('Kullanıcı adı veya şifre yanlış');
    }
    throw new Error(data.failMessage || 'Giriş başarısız oldu');
  }

  return data;
}
// Send reset code
export async function sendResetCode(email) {
  const response = await fetch(`${API_BASE_URL}/Student/send-reset-code?email=${encodeURIComponent(email)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.failMessage || 'Doğrulama kodu gönderilemedi');
  }

  return data;
}

// Reset password
export async function resetPassword({ email, newPassword, emailVerificationCode }) {
  const response = await fetch(`${API_BASE_URL}/Student/reset-password`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, newPassword, emailVerificationCode }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.failMessage || 'Şifre sıfırlama başarısız');
  }

  return data;
}

// NEW: Ticket Based Password Reset Request
export async function requestPasswordResetTicket(email) {
  const response = await fetch(`${API_BASE_URL}/Admin/request-password-reset`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  });
  
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.failMessage || 'İstek gönderilemedi');
  }
  return data;
}
